import { cn } from '@discover-lib/utils';
import Skeleton, { type SkeletonProps } from '@discover-ui/skeleton';
import availabilityCarouselItemVariants from './variants';

export type AvailabilityCarouselItemSkeletonProps = SkeletonProps;

export default function AvailabilityCarouselItemSkeleton({
  className,
  ...props
}: AvailabilityCarouselItemSkeletonProps) {
  return <Skeleton className={cn(availabilityCarouselItemVariants(), className)} {...props} />;
}
